module.exports = __webpack_public_path__ + "media/images/shared/delivery/avtotreyding-1696602cef3562e3124c87f70ea6cbaf.jpg";